import React from 'react';

import './css/DayGroupSeparator.css';


const DayGroupSeparator = ({ dateGroup }) => (
  <div className="messages-date-group-separator">
    <span className="date-label">{dateGroup}</span>
  </div>
);

export default DayGroupSeparator;
